import type {State} from 'src/reducers';
import type {Thread} from 'src/types/messages';
import type {QueueBasedInbox} from 'src/types/chat/queues';
import type {LATQueueEntry} from 'src/types/live-agent-transfer';

import {createSelector} from 'reselect';

import {values} from 'src/utils/object';
import {first} from 'src/utils/array';


export const selectQueueBasedInboxesArray: (arg1: State) => QueueBasedInbox[] =
  createSelector(
    (state: State) => state.chat.queues.queue_based_inboxes,
    (queues): QueueBasedInbox[] => values(queues),
  );

export const selectIsQueueBasedInbox: (state: State) => boolean =
  createSelector(
    selectQueueBasedInboxesArray,
    (queues): boolean => queues.length > 0,
  );

export const selectCurrentQueue = (
  state: State,
): QueueBasedInbox | null | undefined => {
  return (
    state.chat.queues.queue_based_inboxes[
      // @ts-expect-error - TS2339 - Property 'selectedPhoneNumberSetId' does not exist on type 'never'.
      state.chat.multiNumberInbox.selectedPhoneNumberSetId
    ] ||
    selectPrimaryQueue(state) ||
    selectFirstQueue(state)
  );
};

export const selectPrimaryQueue: (
  arg1: State,
) => QueueBasedInbox | null | undefined = createSelector(
  selectQueueBasedInboxesArray,
  (queues): QueueBasedInbox | null | undefined =>
    queues.find((queue) => queue.is_primary),
);

export const selectCurrentQueueId: (arg1: State) => string | null | undefined =
  createSelector(
    selectCurrentQueue,
    (queues): string | null | undefined => queues?.queue_id,
  );

export const selectFirstQueue = (
  state: State,
): QueueBasedInbox | null | undefined =>
  first(selectQueueBasedInboxesArray(state));

export const selectQueueStats: (arg1: State) => LATQueueEntry[] =
  createSelector(
    selectCurrentQueue,
    (state) => state.chat.queues.queues,
    // @ts-expect-error - TS2339 - Property 'queue_id' does not exist on type 'LATQueueEntry'.
    (queueInbox, queues) => queues[queueInbox?.queue_id],
  );

// @ts-expect-error - TS2322 - Type 'OutputSelector<any, unknown[], (res1: unknown[], res2: QueueBasedInbox | null | undefined) => unknown[]>' is not assignable to type '(arg1: any) => Thread[]'.
export const selectQueueThreads: (arg1: State) => Thread[] = createSelector(
  // @ts-expect-error - TS2339 - Property 'threads' does not exist on type 'never'.
  (state) => values(state.messages.threads),
  selectCurrentQueue,
  (threads, queue) =>
    threads.filter((thread) => {
      // @ts-expect-error - TS18046 - 'thread' is of type 'unknown'.
      return thread.queueId === queue?.queue_id;
    }),
);

export const selectNewChatJoinLoadingStatus = (state: State): boolean =>
  state.chat.queues.isLoading;

export const selectCurrentNotificationId = (state: State): string =>
  state.chat.queues.notificationId;

export const selectQueueSoundSetting = (state: State, id: string): boolean => {
  const queues: QueueBasedInbox[] = values(
    state.chat.queues.queue_based_inboxes,
  );
  const queueWithId = queues.find((queue) => queue.queue_id === id);
  return queueWithId?.messaging_sound_setting || false;
};
